import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TransactionalEmailComponent } from "./transactional-email.component";
import { ComponentsModule } from "../../../components/components.module";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";
import { TableModule } from "primeng/table";
import { RouterModule } from "@angular/router";
import { TagModule } from "primeng/tag";
import { TransactionalEditComponent } from "./transactional-edit/transactional-edit.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { ComponentsModule as MarketingComponentsModule } from "../components/components.module";
import { PickListModule } from "primeng/picklist";
import { DropdownModule } from "primeng/dropdown";
import { TableDataModule } from "../../../components/table-data/table-data.module";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { InputSwitchModule } from "primeng/inputswitch";
import { RippleModule } from "primeng/ripple";
import { TextareaModule } from "primeng/textarea";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { DmpSharedLibsModule } from "../../../../legacy/shared-libs/shared-libs.module";
import { PipesModule } from "../../../pipes/pipes.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SelectButtonModule } from "primeng/selectbutton";
import { MenuModule } from "primeng/menu";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
    declarations: [
        TransactionalEmailComponent,
        TransactionalEditComponent,
    ],
    exports: [TransactionalEmailComponent, TransactionalEditComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        ConfirmDialogModule,
        ToastModule,
        TableModule,
        RouterModule,
        TagModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        InputTextModule,
        MarketingComponentsModule,
        PickListModule,
        DropdownModule,
        ScrollPanelModule,
        TableDataModule,
        InputSwitchModule,
        RippleModule,
        TextareaModule,
        OverlayPanelModule,
        SelectButtonModule,
        MenuModule,
        DialogModule,
        TooltipModule,
        DmpSharedLibsModule,
        PipesModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            isolate: false,
        }),
    ],
})
export class TransactionalEmailModule {}
